import { Notification } from "@/types/types"
import { User } from "@/schemas/User"
import { logger } from "@/utils/logger"
import { create } from "zustand"

export type GlobalStore = {
  captchaVisible: boolean
  hotjarVisible: boolean

  playbackSpeed: null | number
  currentUser: null | User
  currentUserStatus: null | "NOT_LOGGED_IN" | "ONBOARDING" | "ACTIVE" | "EXPIRED" | "REVOKED"
  currentLicenseType: null | "full" | "demo"
  activeModal: null | "ONBOARDING" | "EXPIRED" | "REVOKED"
  notificationsQueue: null | Notification[]
  changelogUnreadCount: null | number

  onSectionPage: null | boolean
  mobileAudioPlayerEnabled: null | boolean
  audioPlayerPlaybackSpeed: null | number
  mobileAudioPlayerAutoPlay: boolean

  termsVideoUrl: null | string // replace with cached query

  supportWidgetPanel: null | "welcome" | "contact" | "knowledge"

  update: (storePartial: Partial<GlobalStore>) => void
}

export const useGlobalStore = create<GlobalStore>((set) => ({
  captchaVisible: true,
  hotjarVisible: true,

  playbackSpeed: null,
  currentUser: null,
  currentUserStatus: null,
  currentLicenseType: null,
  activeModal: null,
  notificationsQueue: null,
  changelogUnreadCount: null,

  onSectionPage: null,
  mobileAudioPlayerEnabled: null,
  audioPlayerPlaybackSpeed: null,
  mobileAudioPlayerAutoPlay: false,

  termsVideoUrl: null,

  supportWidgetPanel: null,

  update: (storePartial) =>
    set((state) => {
      logger.debug("[Store:State] Updated", storePartial)
      return { ...state, ...storePartial }
    }),
}))
